export class Manager {
    public username: string;
    public password: string;
}


// WEBPACK FOOTER //
// ./src/holiday/models/Manager.ts